import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Twitter, MessageCircle, Github, Mail, Send } from 'lucide-react';

const Footer = () => {
  const footerLinks = {
    ecosystem: [
      { name: 'Dobix Wallet', path: '/wallet' },
      { name: 'Staking', href: '#' },
      { name: 'Trading Bot', href: '#' },
      { name: 'Dobix Pay', href: '#' },
    ],
    resources: [
      { name: 'Whitepaper', href: '#' },
      { name: 'Documentation', href: '#' },
      { name: 'Brand Assets', href: '#' },
      { name: 'API', href: '#' },
    ],
    company: [
      { name: 'About', path: '/about' },
      { name: 'Roadmap', path: '/roadmap' },
      { name: 'Careers', href: '#' },
      { name: 'Contact', href: '#' },
    ],
    socials: [
      { icon: Twitter, href: '#', label: 'Twitter' },
      { icon: MessageCircle, href: '#', label: 'Discord' },
      { icon: Send, href: '#', label: 'Telegram' },
      { icon: Github, href: '#', label: 'GitHub' },
    ],
  };

  return (
    <footer className="bg-[#0A0A0A] border-t border-[#222222]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <img
                src="/dobix-logo.png"
                alt="Dobix Coin"
                className="h-12 w-12 object-contain"
              />
              <span className="text-2xl font-bold text-gradient font-heading">
                DOBIX
              </span>
            </div>
            <p className="text-gray-400 text-sm mb-6 max-w-sm">
              The people's cryptocurrency. Powering the next generation of decentralized payments and messaging on Solana.
            </p>
            <div className="flex space-x-3">
              {footerLinks.socials.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  className="w-10 h-10 card-dark rounded-xl flex items-center justify-center text-gray-400 hover:text-[#FF6B00] hover:border-[#FF6B00] transition-all"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Ecosystem */}
          <div>
            <h3 className="text-white font-semibold mb-4">Ecosystem</h3>
            <ul className="space-y-3">
              {footerLinks.ecosystem.map((link) => (
                <li key={link.name}>
                  {link.path ? (
                    <Link
                      to={link.path}
                      className="text-gray-400 hover:text-[#FF6B00] text-sm transition-colors"
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-[#FF6B00] text-sm transition-colors"
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-white font-semibold mb-4">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-[#FF6B00] text-sm transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  {link.path ? (
                    <Link
                      to={link.path}
                      className="text-gray-400 hover:text-[#FF6B00] text-sm transition-colors"
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-gray-400 hover:text-[#FF6B00] text-sm transition-colors"
                    >
                      {link.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#222222] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © 2025 Dobix Coin. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm">Privacy Policy</a>
            <a href="#" className="text-gray-500 hover:text-gray-300 text-sm">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;